/**
 * Glasovni katalog za TTS — skupen klientu in strežniku (brez skrivnosti).
 *
 * Piper (self-hosted) je privzeti in vedno na voljo; Azure glasova sta
 * opt-in (cloud, Microsoft EU regija) in se pojavita šele, ko je na
 * strežniku nastavljen AZURE_SPEECH_KEY — filtriranje opravi
 * /api/voice/voices, klient kataloga ne filtrira sam.
 */

export type TtsProviderId = 'piper' | 'azure';

export interface VoiceDef {
  /** Stabilen id — persistira se v localStorage in potuje v /api/voice/tts. */
  id: string;
  /** Ime za prikaz v nastavitvah. */
  label: string;
  provider: TtsProviderId;
  /** true = besedilo odgovora zapusti našo infrastrukturo (opt-in, DRO caveat). */
  cloud: boolean;
}

export const VOICES: VoiceDef[] = [
  { id: 'piper-artur', label: 'Artur (Piper, lokalni)', provider: 'piper', cloud: false },
  { id: 'azure-petra', label: 'Petra (Azure, oblak)', provider: 'azure', cloud: true },
  { id: 'azure-rok', label: 'Rok (Azure, oblak)', provider: 'azure', cloud: true },
];

export const DEFAULT_VOICE_ID = 'piper-artur';

export function getVoiceDef(id: string | null | undefined): VoiceDef | undefined {
  return VOICES.find((v) => v.id === id);
}
